// eslint-disable-next-line no-restricted-imports
import {useDispatch as useDispatchOriginal} from 'react-redux'
import {Action} from '../state/state'
import {Dispatch} from 'redux'

export const useDispatch = () => useDispatchOriginal<Dispatch<Action>>()
